import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Keeps the canonical URL in sync with the current route.
 *
 * `public/index.html` ships a canonical for the homepage, but this is a
 * single-page app: every route is served that same markup. Left alone,
 * /about, /portfolio, /contact and friends would each declare themselves a
 * duplicate of "/" and could be dropped from the index. The static tag in
 * index.html stays as the pre-JS default for the homepage.
 */
const SITE_URL = "https://dev-shohan.netlify.app";

const KNOWN_ROUTES = [
  "/",
  "/about",
  "/portfolio",
  "/experience",
  "/certification",
  "/education",
  "/contact",
];

export default function CanonicalUrl() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Unknown paths render the not-found page (served with a 200 by the SPA
    // fallback), so leave the homepage canonical in place for those.
    if (!KNOWN_ROUTES.includes(pathname)) return;

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${SITE_URL}${pathname}`;
  }, [pathname]);

  return null;
}
